export default __webpack_public_path__ + "img/7f215e0ae656d58903b3e8c948dad521.jpg";